import { render } from "./App.vue?vue&type=template&id=95ae35c2"
const script = {}

import "./App.vue?vue&type=style&index=0&id=95ae35c2&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\21-century-edm-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__